<style lang="scss">
@import '../assets/sass/abstracts/_variables.scss';

div#app-layout {
  div.show-filters {
    height: 90px;
    width: 23px;
    position: absolute;
    left: 0px;
    background-color: white;
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
    line-height: 90px;
    top: 50%;
    cursor: pointer;
    margin-top: -45px;
    z-index: 401;
    text-align: center;
    border-bottom: 1px solid $nina-gray;
    border-top: 1px solid $nina-gray;
    border-right: 1px solid $nina-gray;
  }
}
</style>

<template>
  <div id="app-layout">
    <div class="show-filters" v-show="( !showFilters)" v-on:click="toggleShowFilters()">
      <img :src="require('@/assets/img/grey-right.svg')">
    </div>
    <error-notification></error-notification>
    <navigation></navigation>
    <router-view></router-view>
  </div>
</template>

<script>
import Navigation from '../components/global/Navigation.vue';
import ErrorNotification from '../components/global/ErrorNotification.vue';
export default {
  components: {
    Navigation,
    ErrorNotification
  },
  computed: {
    showFilters() {
      return this.$store.getters.getShowFilters;
    }
  },
  methods: {
    toggleShowFilters() {
      this.$store.dispatch('toggleShowFilters', {
        showFilters: !this.showFilters
      });
    }
  }
};
</script>
